import { useTranslation } from "@/shared/providers/LanguageProvider";

export function LanguageSwitcher() {
  const { locale, setLocale } = useTranslation();

  const toggle = () => setLocale(locale === "en" ? "fr" : "en");

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={locale === "en" ? "Switch to French" : "Passer en anglais"}
      className="flex h-11 w-full items-center justify-center rounded-xl bg-card-muted text-sm font-semibold uppercase text-muted-foreground transition-colors hover:bg-accent/20 hover:text-primary"
    >
      {locale}
    </button>
  );
}
